import { useState } from "react";
import { Input } from "@/components/ui/input";
import { eur } from "@/lib/pricing";

export const NameAutocomplete = ({ line, catalog, onText, onPick }) => {
  const [open, setOpen] = useState(false);
  const [active, setActive] = useState(0);
  const term = (line.name || "").trim().toLowerCase();
  const words = term.split(/\s+/).filter(Boolean);
  const matches = term.length >= 2 && !line.item_id
    ? catalog.filter((i) => words.every((w) => `${i.name} ${i.category}`.toLowerCase().includes(w))).slice(0, 8)
    : [];
  const pick = (it) => { onPick(it); setOpen(false); };
  const onKey = (e) => {
    if (!open || !matches.length) return;
    if (e.key === "ArrowDown") { e.preventDefault(); setActive((a) => Math.min(a + 1, matches.length - 1)); }
    if (e.key === "ArrowUp") { e.preventDefault(); setActive((a) => Math.max(a - 1, 0)); }
    if (e.key === "Enter") { e.preventDefault(); pick(matches[active]); }
    if (e.key === "Escape") setOpen(false);
  };
  return (
    <div className="relative flex-1 min-w-0">
      <Input
        value={line.name}
        onChange={(e) => { onText(e.target.value); setOpen(true); setActive(0); }}
        onFocus={() => setOpen(true)}
        onBlur={() => setTimeout(() => setOpen(false), 150)}
        onKeyDown={onKey}
        placeholder="Scrivi per cercare nel listino..."
        className="h-8 text-sm font-medium"
        autoComplete="off"
        data-testid={`line-name-${line.id}`}
      />
      {open && matches.length > 0 && (
        <div className="absolute z-50 mt-1 w-[min(640px,90vw)] max-h-80 overflow-y-auto rounded-md border border-slate-700 bg-slate-900 shadow-xl py-1" data-testid={`line-suggestions-${line.id}`}>
          {matches.map((it, i) => (
            <button
              key={it.id}
              type="button"
              onMouseDown={(e) => { e.preventDefault(); pick(it); }}
              className={`w-full text-left px-3 py-1.5 flex items-center gap-3 text-sm ${i === active ? "bg-slate-800" : "hover:bg-slate-800/60"}`}
              data-testid={`line-suggestion-${it.id}`}
            >
              <span className="text-[10px] font-mono text-slate-500 w-16 shrink-0 truncate">{it.category}</span>
              <span className="flex-1 leading-snug">{it.name}</span>
              <span className="font-mono text-xs text-slate-400">{eur(it.price)}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
};
